import {useEffect, useState} from 'react'
import {Dispatch} from 'redux'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import * as auth_actions from '../../../../setup/redux/auth/actions'
import {Link, useNavigate} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Loader} from '../../../services/Loader'
import {IsCurrentPlanFree} from '../../../services/Functional'
import UpgradePlanDialog from '../../subscription_history/my_subscription/UpgradePlanDialog'

function AccessDeniedPage() {
  const dispatch: Dispatch<any> = useDispatch()
  const navigate = useNavigate()
  const [showUpgradeDialog, setShowUpgradeDialog] = useState(false)

  const {user, subscription_renew_check, pageLoading, renew_company_id}: any =
    useSelector<RootState>(
      (state) => ({
        user: state.auth.user,
        subscription_renew_check: state.auth.subscription_renew_check,
        renew_company_id: state.auth.renew_company_id,
        pageLoading: state.auth.isPageLoading,
      }),
      shallowEqual
    )
  useEffect(() => {
    const fetchData = async () => {
      if (renew_company_id) {
        let response: any = await dispatch(
          auth_actions.getInspectionCompanyById(renew_company_id, 'show')
        )
        if (response.code === 200 || response.code === 201) {
          const upgradeRequest = response.data.inspection_company.upgrade_plan_requests.find(
            (request: any) =>
              request.is_upgrade_payment_required === true &&
              request.payment_status === 'pending' &&
              request.upgrade_payment_link &&
              request.upgrade_payment_link.trim() !== ''
          )
          if (upgradeRequest) {
            navigate('/logout')
          }
        }
      }
    }

    fetchData()

    const intervalId = setInterval(() => {
      fetchData()
    }, 30000)

    return () => {
      clearInterval(intervalId)
    }
  }, [renew_company_id, dispatch])

  const isCurrentPlanFree = IsCurrentPlanFree(true)

  useEffect(() => {
    if (!user || !subscription_renew_check || subscription_renew_check > 0) {
      navigate('/logout')
    }
  }, [user])

  useEffect(() => {
    const handleBackButton = (event: PopStateEvent) => {
      event.preventDefault()
      navigate('/access-denied', {replace: true})
    }

    window.addEventListener('popstate', handleBackButton)

    return () => {
      window.removeEventListener('popstate', handleBackButton)
    }
  }, [navigate])

  useEffect(() => {
    dispatch(auth_actions.handlePageLoading(false))
  }, [])

  const handleProceedToPaymentButton = async () => {
    dispatch(auth_actions.handlePageLoading(true))
    await dispatch(auth_actions.renewSubscriptionPlan(renew_company_id))
  }

  const handleUpgradeClick = () => {
    setShowUpgradeDialog(true)
  }

  const handleUpgradeDialogClose = () => {
    setShowUpgradeDialog(false)
  }

  return (
    <>
      {pageLoading && <Loader />}
      <div className='vertical_center'>
        <div className='d-flex flex-column align-items-center item-container'>
          <img alt='' className='error-img mb-7' src={toAbsoluteUrl('/media/access-denied.svg')} />
          <h1 className='fw-bolder fs-4x text-gray-700 mb-7 text-center'>Access is denied!</h1>
          <div className='fw-bold fs-3 text-gray-400 mb-10 text-center'>
            Your Plan is expired!
            <br /> Make payment to access your account.
          </div>
          <div className='text-center d-flex gap-3 flex-column-reverse flex-md-row flex-wrap justify-content-center'>
            <Link to='/logout' className='btn btn-lg btn-primary fw-bolder'>
              Logout
            </Link>
            {!isCurrentPlanFree && (
              <button
                onClick={handleProceedToPaymentButton}
                className='btn btn-lg btn-primary fw-bolder'
              >
                Renew Plan
              </button>
            )}
            <button onClick={handleUpgradeClick} className='btn btn-lg btn-primary fw-bolder'>
              Upgrade Plan
            </button>
          </div>
        </div>
      </div>
      <UpgradePlanDialog
        show={showUpgradeDialog}
        onHide={handleUpgradeDialogClose}
        currentPlanBadgeText='Expired Plan'
      />
    </>
  )
}

export default AccessDeniedPage
